import AnimatedContent from "@/components/animatedContent";
import CustomCursor from "@/components/customCursor";
import Footer from "@/components/footer";
import ScrollProgress from "@/components/scrollProgress";
import V13Styles from "@/components/styles";
import NavBar from "@/components/ui/navbar";
import { useLocation } from "react-router-dom";

// ===================== PAGE LAYOUT =====================
const PageLayout = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <div className="v13-root min-h-screen pt-20 lg:pt-24">
      <V13Styles />
      <CustomCursor />
      <ScrollProgress />
      <NavBar />
      <AnimatedContent key={pathname}>{children}</AnimatedContent>
      <Footer />
    </div>
  );
};

export default PageLayout;